export enum RateCategoryTypeEnum {
    IndustrialUnUso = 1,
    ComercialUnUso = 2,
    IndustrialReutilizableSDDRCerrado = 3,
    ComercialReutilizableSDDRCerrado = 4,
    IndustrialReutilizableSDDRAbierto = 5,
    ComercialReutilizableSDDRAbierto = 6,
    Domesticos = 7,
    IndustrialReutilizableSDDRAbiertoSinGobernanza = 10,
    ComercialReutilizableSDDRAbiertoSinGobernanza = 11
}